import React, { useEffect } from 'react';
import { updateAuthState, initializeRioClient } from '@chegg-me-components/utils';
import HeaderLogoLink from '../shared/HeaderLogoLink';
import HeaderShell from '../shared/HeaderShell';

var NoDistractionsHeader = function NoDistractionsHeader(_ref) {
  var envUrl = _ref.envUrl,
      mainContentId = _ref.mainContentId,
      navType = _ref.navType,
      rioConfig = _ref.rioConfig,
      dataTest = _ref['data-test'];
  useEffect(function () {
    /**
     * Initialize Rio Client
     */
    if (rioConfig) {
      initializeRioClient(rioConfig);
    }
    /**
     * This function will update the rio-client
     * state if user is logged in
     */


    updateAuthState();
  }, []);
  return /*#__PURE__*/React.createElement(HeaderShell, {
    mainContentId: mainContentId,
    "data-test": dataTest
  }, /*#__PURE__*/React.createElement(HeaderLogoLink, {
    envUrl: envUrl,
    navType: navType
  }));
};

NoDistractionsHeader.displayName = 'NoDistractionsHeader';
export default NoDistractionsHeader;